var _templateObject, _templateObject2, _templateObject3;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import React from 'react';
import { Tooltip } from 'antd';
import styled from 'styled-components';
import { useDataAtomValues, useStateAtomValues } from '../../state';
import { UseBeforePayGlobalStyle, useSettleAmountFormatter, useDisabledPay } from '../../hooks';
import { useTranslation } from '../../_utils/i18n';
import { Title1, CustomButton } from '../../styled';
import PayCanceller from './payCanceller';
import usePayModules from './usePayModules';
var PayWrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-top: 24px;\n  border-top: 1px solid #d7dbe7;\n  padding-top: 20px;\n"])));
var PayAmountLabel = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 12px;\n"])), function (props) {
  return props.theme.primaryTextColor;
});
var PayAmountValue = styled(Title1)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-right: 24px;\n"])), function (props) {
  return props.theme.primaryTextColor;
});
var PayButton = function PayButton(_ref) {
  var _ref$decorativeButton = _ref.decorativeButton,
    decorativeButton = _ref$decorativeButton === void 0 ? true : _ref$decorativeButton,
    _ref$cancelButton = _ref.cancelButton,
    cancelButton = _ref$cancelButton === void 0 ? false : _ref$cancelButton;
  var _useDataAtomValues = useDataAtomValues(),
    billDetail = _useDataAtomValues.billDetail;
  var _useStateAtomValues = useStateAtomValues(),
    payLoading = _useStateAtomValues.payLoading,
    notCanPayUpgradeSubBill = _useStateAtomValues.notCanPayUpgradeSubBill;
  // 当账单为已取消或已成功支付、或正在支付中时，账单不可支付
  var disabledPay = useDisabledPay();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _usePayModules = usePayModules(),
    modules = _usePayModules.modules,
    payHandlers = _usePayModules.payHandlers;
  var settleAmountFormatter = useSettleAmountFormatter();

  // 不可以支付的提示文案
  var disabledPayTipText = notCanPayUpgradeSubBill ? t('settlement.upgrade.note1') : '';
  var payEntry = /*#__PURE__*/React.createElement(React.Fragment, null, cancelButton && /*#__PURE__*/React.createElement(PayCanceller, {
    onPayCancel: payHandlers.handlePayCancel
  }), /*#__PURE__*/React.createElement(Tooltip, {
    title: disabledPayTipText,
    overlayStyle: {
      display: disabledPayTipText ? '' : 'none'
    }
  }, /*#__PURE__*/React.createElement(CustomButton, {
    type: "primary",
    disabled: disabledPay || payLoading,
    loading: !disabledPay && payLoading,
    onClick: payHandlers.payHandler
  }, t('settlement.pay now'))), modules);
  return decorativeButton ? /*#__PURE__*/React.createElement(PayWrapper, null, /*#__PURE__*/React.createElement(UseBeforePayGlobalStyle, null), /*#__PURE__*/React.createElement(PayAmountLabel, null, t('settlement.final.paymentamount'), "\uFF1A"), /*#__PURE__*/React.createElement(PayAmountValue, null, settleAmountFormatter((billDetail === null || billDetail === void 0 ? void 0 : billDetail.settleAmount) || 0, {
    code: billDetail === null || billDetail === void 0 ? void 0 : billDetail.orderCurrency
  })), payEntry) : payEntry;
};
export default PayButton;